import { render, staticRenderFns } from "./CompraPorAnio.vue?vue&type=template&id=4218f652&"
import script from "./CompraPorAnio.vue?vue&type=script&lang=js&"
export * from "./CompraPorAnio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports